import { Component, OnInit, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { MatSnackBar } from "@angular/material/snack-bar";
import { LoginService } from "../services/login.service";
import { LoginRequestModel } from "../model/LoginRequestModel";
import { FormGroup } from "@angular/forms";
import {RecaptchaComponent} from 'ng-recaptcha';

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"],
})
export class LoginComponent implements OnInit {
  username: string = "";
  password: string = "";
  maskMobileNumber : string;
  isCaptchaClicked: boolean;
  isOtpVerify: boolean = false;
  loginForm: FormGroup;
  captcha: string;
  resendOtpIn: any = null;
  timerOn = true;
  isResendOtpButtonVisible: boolean = false;
  pageHead: string = "Login";
  @ViewChild('captchaElem') captchaElem: RecaptchaComponent;
  
  luser: LoginRequestModel = new LoginRequestModel();

  constructor(private router: Router, private _snackBar: MatSnackBar, 
    private loginService: LoginService) {
      this.captcha='';
    }

  ngOnInit(): void {}

  showPassword = false;
  showConfirmPassword = false;
  toggleShowPassword() {
    this.showPassword = !this.showPassword;
  }

  resolved(captchaResponse: string){
    this.captcha = captchaResponse;
    this.luser.captchaRes = captchaResponse;
    this.isCaptchaClicked = true;
    console.log('resolved captcha with response '+ this.captcha);
    console.warn('resolved captcha with response '+ this.captcha);
  }
  
  signIn() {
    if (this.username != null && this.password !=null) {
      if(this.isCaptchaClicked){
        this.loginService.login(this.luser).subscribe((data: any)=>{
          console.log("Login SuccessFull*******",data);
          if(data.status =="SUCCESS"){
            this.maskMobileNumber = data.maskMobileNumber;
              this.pageHead = "OTP Verification";
              this.isOtpVerify = true;
              this.resendOtpTimer(120);
         //   localStorage.setItem("accessToken", data.accessToken);
         //   localStorage.setItem("expiresIn", data.expiresIn);
         //   localStorage.setItem("refreshToken", data.refreshToken);
         //   localStorage.setItem("roles", data.roles);
         //   localStorage.setItem("userName", data.userName);
         //   this.router.navigate(['/secure', 'home']);
          }
          if(data.status == "FAILURE"){
            this.isCaptchaClicked = false;
            this.captchaElem.reset();
            alert("Try After 30 Minutes : Exceeded the OTP limit");
          }
          if(data.status == "ERROR"){
            this.isCaptchaClicked = false;
            this.captchaElem.reset();
            alert("Please Try Again");
          }
        }, error=> {
          this.isCaptchaClicked = false;
          this.captchaElem.reset();
          this._snackBar.open("Invalid username or password", "Close", {
          horizontalPosition: "right",
          verticalPosition: "top",
          panelClass: "warning-toast",
          duration: 3 * 1000,
        })});
      }else{
        this.captchaElem.reset();
        this._snackBar.open("Please verify the captcha", "Close", {
          horizontalPosition: "right",
          verticalPosition: "top",
          panelClass: "warning-toast",
          duration: 3 * 1000,
        });
      }
    } else {
      this._snackBar.open("Invalid username or password", "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "warning-toast",
        duration: 3 * 1000,
      });
    }
  }
  verifyOtp() {
    if (this.username != null && this.password !=null) {
      if(this.isCaptchaClicked){
        this.loginService.otpVerification(this.luser).subscribe((data: any)=>{
          console.log("Login SuccessFull*******",data);
          console.log("Login SuccessFull****data.status***",data.status);
          console.log("Login SuccessFull***data.errorMessage****",data.errorMessage);
          console.log(data.status == "FAILURE");
          if(data.status =="SUCCESS"){
            localStorage.setItem("accessToken", data.accessToken);
            localStorage.setItem("expiresIn", data.expiresIn);
            localStorage.setItem("refreshToken", data.refreshToken);
            localStorage.setItem("roles", data.roles);
            localStorage.setItem("userName", data.userName);
            localStorage.setItem("userId", data.userId);
            this.router.navigate(['/secure', 'home']);

          } 
        //  if(data.status == "FAILURE"){
            else {
          //  console.log("Check data for failure",data);
            alert(data.errorMessage);
          }
        }, error=> {
          this.isCaptchaClicked = false;
          this.captchaElem.reset();
          alert("Invalid OTP");
          this._snackBar.open("Invalid username or password", "Close", {
          horizontalPosition: "right",
          verticalPosition: "top",
          panelClass: "warning-toast",
          duration: 3 * 1000,
        })});
      }else{
        this.captchaElem.reset();
        this._snackBar.open("Please verify the captcha", "Close", {
          horizontalPosition: "right",
          verticalPosition: "top",
          panelClass: "warning-toast",
          duration: 3 * 1000,
        });
      }
    } else {
      this._snackBar.open("Invalid username or password", "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "warning-toast",
        duration: 3 * 1000,
      });
    }
  }
  
  back(){
    this.username = "";
    this.password = "";
    this.isOtpVerify = false;
    this.pageHead = "Login";
  }

  numberOnly(event: any) {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  resendOtpTimer(remaining: any) {
    var m: any = Math.floor(remaining / 60);
    var s: any = remaining % 60;

    m = m < 10 ? "0" + m : m;
    s = s < 10 ? "0" + s : s;
    this.resendOtpIn = m + ":" + s;
    localStorage.setItem("otpResendTimeLeft", this.resendOtpIn);
    remaining -= 1;

    if (remaining >= 0 && this.timerOn) {
      setTimeout(() => {
        this.resendOtpTimer(remaining);
      }, 1000);
      return;
    }

    if (!this.timerOn) {
      // Do validate stuff here
      return;
    } else {
      // Do timeout stuff here
      // alert('Timeout for otp');
      this.isResendOtpButtonVisible = true;
    }
  }

  onResendOtpClick() {
    // this.resendOtp = "Y";
    this.isResendOtpButtonVisible = false;
    this.resendOtp();
  }

  resendOtp() {
    if (this.username != null && this.password !=null) {
        this.loginService.resendOtp(this.luser).subscribe((data: any)=>{
          console.log("Login SuccessFull*******",data);
          if(data.status =="SUCCESS"){
              this.successToast("OTP Resend successfully.");
              this.maskMobileNumber = data.maskMobileNumber;
              this.pageHead = "OTP Verification";
              this.isOtpVerify = true;
              this.resendOtpTimer(120);
          }
          if(data.status == "ERROR"){
            alert("Please Try Again");
          }
        }, error=> {
          this._snackBar.open("Invalid username or password", "Close", {
          horizontalPosition: "right",
          verticalPosition: "top",
          panelClass: "warning-toast",
          duration: 3 * 1000,
        })});
     
    } else {
      this._snackBar.open("Invalid username or password", "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "warning-toast",
        duration: 3 * 1000,
      });
    }
  }

  async successToast(msg) {
    await this._snackBar.open(
      msg,
      "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "success-toast",
        duration: 3 * 1000,
      }
    );
  }

  resetFilter() {
    window.location.reload();
   
  }
}
